// Lightweight EN→ES UI dictionary. Language is per device (localStorage);
// the LangToggle reloads the page so every screen re-renders in the new language.
export const getLang = () => {
  try {
    // Spanish is a WORKER-portal feature only. Admin/colony/driver areas are
    // always English, even if this browser once set app_lang elsewhere.
    if (!window.location.pathname.startsWith("/worker")) return "en";
    return localStorage.getItem("app_lang") || "en";
  } catch { return "en"; }
};
export const setLangPref = (l) => {
  try { localStorage.setItem("app_lang", l); } catch { /* private mode */ }
};

const ES = {
  "Calendar year": "Año calendario",
  "Scroll statuses left": "Desplazar estados a la izquierda",
  "Scroll statuses right": "Desplazar estados a la derecha",
  "Could not load the photos. Please try again.": "No se pudieron cargar las fotos. Inténtalo de nuevo.",
  "Loading…": "Cargando…",
  "Retry": "Reintentar",
  // worker header
  "My assignments": "Mis asignaciones",
  "across": "en",
  "colony": "colonia",
  "colonies": "colonias",
  "ticket": "ticket",
  "tickets": "tickets",
  "As a worker manager you see tickets from every colony.": "Como encargado, ves los tickets de todas las colonias.",
  "You see tickets from colonies where the office has added you as a watcher.": "Ves los tickets de las colonias donde la oficina te agregó como observador.",
  "Refresh": "Actualizar",
  "Watch tutorial": "Ver tutorial",
  "Loading video…": "Cargando video…",
  "Could not load this tutorial.": "No se pudo cargar este tutorial.",
  "This video could not be played. Please try again.": "No se pudo reproducir este video. Inténtalo de nuevo.",
  "No video has been added for this section yet.": "Todavía no se ha añadido un video para esta sección.",
  "Worker main page — English": "Página principal del trabajador — Inglés",
  "Worker main page — Español": "Página principal del trabajador — Español",
  "Worker manager main page — English": "Página principal del encargado — Inglés",
  "Worker manager main page — Español": "Página principal del encargado — Español",
  "Expenses": "Gastos",
  "New ticket": "Nuevo ticket",
  "Sign out": "Cerrar sesión",
  "Install app": "Instalar app",
  // filters
  "Status": "Estado",
  "Colony": "Colonia",
  "Sort by": "Ordenar por",
  "All": "Todos",
  "All colonies": "Todas las colonias",
  "Open": "Abierto",
  "In progress": "En progreso",
  "On hold": "En espera",
  "Closed": "Cerrado",
  "Cancelled": "Cancelado",
  "Scheduled": "Programado",
  "Newest first": "Más recientes primero",
  "Oldest first": "Más antiguos primero",
  "Search": "Buscar",
  "Search title, details, notes, people…": "Buscar título, detalles, notas, personas…",
  "to": "hasta",
  // ticket card
  "Filed": "Creado",
  "by": "por",
  "no photos attached": "sin fotos adjuntas",
  "Conversation": "Conversación",
  "Urgent": "Urgente",
  "Add reply": "Responder",
  "Start": "Iniciar",
  "Hold": "Pausar",
  "Close": "Cerrar",
  "Reopen": "Reabrir",
  "Send reply": "Enviar respuesta",
  "Sending…": "Enviando…",
  "Creating…": "Creando…",
  "Hide reply": "Ocultar respuesta",
  "Bungalow colony": "Colonia",
  "Close with photos": "Cerrar con fotos",
  "Skip & close": "Omitir y cerrar",
  "Close ticket": "Cerrar ticket",
  "Upload": "Subir",
  "Camera": "Cámara",
  "Loading tickets…": "Cargando tickets…",
  "Nothing here": "No hay nada aquí",
  "Couldn't load your tickets": "No se pudieron cargar tus tickets",
  "Try again": "Intentar de nuevo",
  "Your session has expired — please sign out and sign back in.": "Tu sesión ha expirado — cierra sesión y vuelve a iniciarla.",
  "Could not load your tickets.": "No se pudieron cargar tus tickets.",
  "No colonies assigned yet": "Aún no tienes colonias asignadas",
  // dialogs
  "New service ticket": "Nuevo ticket de servicio",
  "Title": "Título",
  "Details": "Detalles",
  "Photos (up to 6)": "Fotos (hasta 6)",
  "Assign to": "Asignar a",
  "Date & time": "Fecha y hora",
  "Scheduled date": "Fecha programada",
  "Mark as urgent": "Marcar como urgente",
  "Shows red & jumps to the top": "Se muestra en rojo y sube al principio",
  "Pick a colony…": "Elige una colonia…",
  "Cancel": "Cancelar",
  "Save": "Guardar",
  "Create ticket": "Crear ticket",
  "e.g. Fix leaking pipe at Unit 12": "p. ej., Reparar fuga en la Unidad 12",
  "What did you find? What needs to happen?  (you can also paste a picture here)": "¿Qué encontraste? ¿Qué hay que hacer?  (también puedes pegar una imagen aquí)",
  "Update the colony…  (you can also paste a picture here)": "Escribe una actualización…  (también puedes pegar una imagen aquí)",
  "Optional closing note…  (you can also paste a picture here)": "Nota de cierre opcional…  (también puedes pegar una imagen aquí)",
  // toasts
  "Reply sent to the colony.": "Respuesta enviada a la colonia.",
  "Ticket created.": "Ticket creado.",
  "Ticket updated.": "Ticket actualizado.",
  "Add a note, a photo, or both.": "Agrega una nota, una foto o ambas.",
  "Add a photo or note — or use Skip & close.": "Agrega una foto o nota — o usa Omitir y cerrar.",
  "Give the ticket a short title.": "Escribe un título corto para el ticket.",
  "Pick a colony.": "Elige una colonia.",
  // admin ticket area
  "Colony tickets": "Tickets de colonias",
  "showing": "mostrando",
  "matching": "coincide con",
  "all statuses": "todos los estados",
  "Delete": "Eliminar",
  "Watchers": "Observadores",
  "Assign": "Asignar",
  "Reply": "Responder",
  "Schedule": "Programar",
  "Edit": "Editar",
  "Signed in as": "Sesión iniciada como",
  "Schedule for later (optional)": "Programar para más tarde (opcional)",
  "Assign to specific people (optional)": "Asignar a personas específicas (opcional)",
  // language toggle
  "Language": "Idioma",
};

export const t = (s) => (getLang() === "es" ? (ES[s] ?? s) : s);
